import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';

ReactDOM.render(<App />, document.getElementById('root'));